// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import { logEvent } from 'firebase/analytics';

const firebaseConfig = {
    apiKey: "AIzaSyCW18z8M0AUsCGVVtA9CZew8SmhLnDASHI",
    authDomain: "topela-d140f.firebaseapp.com",
    projectId: "topela-d140f",
    storageBucket: "topela-d140f.firebasestorage.app",
    messagingSenderId: "926300491630",
    appId: "1:926300491630:web:e8c9265ce9739f31e6fb7f",
    measurementId: "G-25N7ZQ434F"
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

// Initialize Firebase analytics
let analytics: any;
isSupported().then((supported) => {
    if (supported) {
        analytics = getAnalytics(firebaseApp);
    }
}).catch(() => { });

const logNewEvent = (eventName: string, eventParams?: any) => {
    if (analytics) {
        logEvent(analytics, eventName, eventParams)
    }
}

export { firebaseApp, analytics, logNewEvent };
